export const lightGeneralColors = {
  primary: {
    main: "#459173",
    light: "#E2F1EB",
    dark: "#70BB9D",
  },
  secondary: {
    main: "#AAB9C5",
    light: "#323F49",
    contrastText: "#92A5B5",
    dark: "#637D92",
  },
  success: {
    main: "#27AE60",
    light: "#6FCF971A",
  },
  error: {
    main: "#f44336",
  },
  warning: {
    main: "#ff9800",
  },
  info: {
    main: "#2196f3",
  },
  text: {
    primary: "#000000",
    secondary: "#0a0b0a",
  },
};

export const darkGeneralColors = {
  primary: {
    main: "#6E25CC",
    light: "#6E25CC1A",
  },
  secondary: {
    main: "#6E25CC1A",
  },
  text: {
    primary: "#7D8590",
    disabled: "#7D859050",
  },
};
